import { UIPosition, UIUser } from 'types';
import OverallSkillsRequired from './OverallSkillsRequired';
import { PositionSkill } from './PositionDrawer';
import RecruiterTechnicalSkillsRequired from './RecruiterTechnicalSkillsRequired';
import { isRecruiterSide } from 'src/config/env.config';

interface Props {
	position: UIPosition;
	userDetail: UIUser;
	positionSkills: PositionSkill[];
}

const RightSection = ({ position, positionSkills }: Props) => {
	if (!positionSkills?.length) {
		return null;
	}

	return (
		<div>
			<div
				style={{
					border: '1px solid transparent',
				}}
				className="mt-[0px] md:mt-[24px]"
			>
				{isRecruiterSide ? (
					<RecruiterTechnicalSkillsRequired position={position} positionSkills={positionSkills} />
				) : (
					<OverallSkillsRequired position={position} positionSkills={positionSkills} />
				)}
			</div>
		</div>
	);
};

export default RightSection;
